module.exports = "<a [href]=\"url\" class=\"btn-nuam\">\n  <i [ngClass]=\"icon\"></i>\n  <span>{{ title }}</span>\n</a>"